import { render } from "./TheHeaderProfile.vue?vue&type=template&id=47dff864"
import script from "./TheHeaderProfile.vue?vue&type=script&lang=js"
export * from "./TheHeaderProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/app/header/TheHeaderProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47dff864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47dff864', __exports__)) {
    console.log('reload')
    api.reload('47dff864', __exports__)
  }
  
  module.hot.accept("./TheHeaderProfile.vue?vue&type=template&id=47dff864", () => {
    console.log('re-render')
    api.rerender('47dff864', render)
  })

}


export default __exports__